import { useMemo } from "react";

import { getFixedTu } from "./getFixedTu";
import { useI18nContext } from "./I18nProvider";
import type { TuFunction } from "./types";

interface UseTuResult {
  tu: TuFunction;
}

export function useTu(namespace: string): UseTuResult {
  const context = useI18nContext();

  const tu = useMemo(
    () =>
      getFixedTu({
        catalogs: context.catalogs,
        fallbackLocale: context.fallbackLocale,
        isEnabled: context.isEnabled,
        locale: context.locale,
        namespace,
      }),
    [context.catalogs, context.fallbackLocale, context.isEnabled, context.locale, namespace]
  );

  return { tu };
}
